import { LoadableLazy } from '@confluence/loadable';

export type { ContextualInviteNudgeFlagBaseProps } from './ContextualInviteNudgeFlag';

export const ContextualInviteNudgeFlagLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualInviteNudgeFlag" */ './ContextualInviteNudgeFlag'
			)
		).ContextualInviteNudgeFlag,
});
